function setCookie (name, value, exp) {
  document.cookie = name + '=' + value + (exp ? '' : '; expires=Tue, 19 Jan 2038 12:14:07 GMT') + '; path=/'
}

function setPromoCookie (name, value) {
  var now = new Date()
  var time = now.getTime()
  time += 60 * 60 * 1000 * 6
  now.setTime(time)
  document.cookie = `${name}=${value}; expires=${now.toGMTString()}; path=/`
}

function getCookie (name) {
  var a = document.cookie.split(';')
  for (var i = 0; i < a.length; i++) {
    var c = a[i].replace(/^\s*/, '')
    if (c.indexOf(name) === 0) {
      return c.substring(name.length + 1, c.length)
    }
  }
}

module.exports = {
  setCookie,
  setPromoCookie,
  getCookie
}



// WEBPACK FOOTER //
// ./src/scripts/utls/cookies.js